import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ThumbnailItem from './ThumbnailItem';
import { MediaActions } from '../../_redux';
import { MediaGalleryConstants } from '../../constants';
import { ThumbnailView } from '../_common';

const { MEDIA_ACTION_FAILED_STATUS, MEDIA_ACTION_STATUS, MEDIA_FROM } = MediaGalleryConstants;

const mapStateToProps = state => ({
  medias: state.media.get(`${MEDIA_FROM.hosted}`).toList().toJS().reverse(),
  progress: state.media.get('progress'),
  selection: state.media.get('selection'),
  // medias: _.orderBy(state.media.get('medias').toList().toJS()
  //   .filter((m) => m.from === MEDIA_FROM.hosted), (m) => m.id, 'asc')
});

const mapDispatchToProps = {
  SET_MEDIA_SELECTION: MediaActions.SET_MEDIA_SELECTION,
};

class HostedMedias extends React.Component {
  static propTypes = {
    selection: PropTypes.object,
    intl: PropTypes.object.isRequired,
    progress: PropTypes.object,
    medias: PropTypes.array,
    checkIsSelectionAllowed: PropTypes.func,
    onCrop: PropTypes.func.isRequired,
    SET_MEDIA_SELECTION: PropTypes.func.isRequired,
  }

  getErrorMsg = failed_status => failed_status === MEDIA_ACTION_FAILED_STATUS.updating_failed &&
    this.props.intl.formatMessage({ id: 'media.upload_failed', defaultMessage: '!Upload failed' })

  getStatusMsg = status => status === MEDIA_ACTION_STATUS.updating &&
    this.props.intl.formatMessage({ id: 'media.updating', defaultMessage: '!Updating...' })

  selectMedia = media => {
    this.props.SET_MEDIA_SELECTION({ ...this.props.selection, media, on: MEDIA_FROM.hosted });
  }

  cropImage = (image, e) => {
    e.stopPropagation();
    if (this.props.onCrop) {
      this.props.onCrop(image);
    }
  }

  render() {
    const {
      medias, progress, selection: { media } = {}, checkIsSelectionAllowed,
    } = this.props;

    return (
      <div className="gallery-container">
        <ThumbnailView
          data={medias}
          selections={media}
          itemRenderer={ThumbnailItem}
          checkIsSelectionAllowed={checkIsSelectionAllowed}
          itemProps={{
            onCrop: this.cropImage,
            uploadProgress: progress,
          }}
          onChange={this.selectMedia}
        />
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(HostedMedias));
